/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type SocialContextEntityType = 'Community' | 'Project' | 'Health Community' | 'Charity Community';

export const SocialContextEntityType = {
    Community: 'Community' as SocialContextEntityType,
    Project: 'Project' as SocialContextEntityType,
    HealthCommunity: 'Health Community' as SocialContextEntityType,
    CharityCommunity: 'Charity Community' as SocialContextEntityType
};